// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

<template>
  <detail-view
  :endpoint="endpoint + 'settings'"
  name="Settings"
  noPathId
  permissions="settings"
  :values="values"
  ></detail-view>
</template>
<script>
import {ENDPOINT} from '@/shared/constants'
import DetailView from 'vue-common/components/DetailView.vue'

export default {
  components: {
    DetailView
  },

  data () {
    return {
      endpoint: ENDPOINT,
      values: [
        {
          name: 'Basic',
          items: [
            [
              {
                name: 'Email Sent From Name',
                value: 'emailFromName'
              },
              {
                name: 'Email Sent From Address',
                value: 'emailFromAddress'
              }
            ]
          ]
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Settings.vue